import { render, staticRenderFns } from "./WKSMenSuoFilePreview.vue?vue&type=template&id=e120b82e&scoped=true"
import script from "./WKSMenSuoFilePreview.vue?vue&type=script&lang=js"
export * from "./WKSMenSuoFilePreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e120b82e",
  null
  
)

export default component.exports